/**
 * description 安全事故
 * created by liu.linhai
 * created on 2017/11/07
 */
"use strict";
angular.module('safetyAccidentModule', [])
    .controller('safetyAccidentController', ['$scope', '$q','$http','trsHttpService', '$filter','modalDialog','storageListenerService', function($scope, $q,$http,trsHttpService, $filter,modalDialog,storageListenerService) {
        initStatus();
        initData();

        /**
         * [initData 初始化数据]
         * @return {[type]} null
         */
        function initData() {
            requestData(); //请求数据
            //请求安全事件列表
            getIncidentList().then(function(){
                getSelectItem();
            });
        }

        /**
         * [getSelectItem description] 获取导航选中项
         * @return {[type]} [description]
         */
        function getSelectItem(){
            var params = {
                'serviceid': 'emergency',
                'modelid': 'getuserconfig',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params, 'post').then(function(data){
                $scope.data.selectedIncident  = angular.copy(data.slice(1,-2).split(";"));
            });
        }

        /**
         * [initStatus 初始化状态]
         * @return {[type]} null
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 0,
                "PAGESIZE": 10,
                "PAGECOUNT": 1,
                "ITEMCOUNT": 0
            };
            $scope.status = {
                copyCurrPage: 1,
                safetyTypeArray: [{
                    name: '全部领域分类',
                    value: ''
                }],
                selectedSafetyType: {
                    name: '全部领域分类',
                    value: ''
                },
                showKeywords: '',
                nowTime: $filter('date')(new Date(), "yyyy-MM-dd").toString()
            };
            $scope.data = {
                areaTeam: [],
                selected_area: '',
                safetyInfoList: [],
                incidentList: [],
                selectedIncident: [],
                checkDate: '',
                keywords: '',
            };
            //分页数据
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE:10,
                ITEMCOUNT: 0,
                PAGECOUNT: 1
            };
            $scope.params = {
                'serviceid': 'emergency',
                'modelid': 'getemergencyinfolist',
                'page_no': $scope.page.CURRPAGE-1,
                'page_size': $scope.page.PAGESIZE,
                // 'area': $scope.data.selected_area,
                'search_word': '',
                "search_date": ''
            };
        };
        /**
         * [timeSwitch 时间格式化]
         * @param  {[type]} time [毫秒数]
         * @return {[type]}      [年-月-日]
         */
        function timeSwitch(time) {
            return $filter('date')(time, 'yyyy-MM-dd').toString();
        }

        /**
         * [requestData 请求数据]
         * @return {[type]} null
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                // $scope.page = {
                //     'ITEMCOUNT': data.TOTALITEMCOUNT,
                //     'PAGECOUNT': data.PAGETOTAL,
                //     'PAGESIZE': data.PAGESIZE,
                //     'CURRPAGE': data.PAGEINDEX + 1
                // };
                $scope.page.ITEMCOUNT = data.PAGEDLIST.TOTALITEMCOUNT;
                $scope.page.PAGECOUNT = data.PAGEDLIST.PAGETOTAL;
                $scope.indexname = !!data.CONTENT ? data.CONTENT.INDEXNAME : "";
                $scope.data.safetyInfoList = !!data.PAGEDLIST ? data.PAGEDLIST.PAGEITEMS : "";
                storageListenerService.previewPageTurningStorage($scope.data.safetyInfoList, "GUID", "resourceDetail");
            });
        }

        /**
         * [selectedAreaInfo 选择地域信息]
         * @return {[type]} null
         */
        $scope.selectedAreaInfo = function(item) {
            $scope.data.selected_area = item.area;
            requestData();
        }

        /**
         * [getIncidentList 请求事故事件栏目]
         * @return {[type]} [null]
         */
        function getIncidentList() {
            var deferred = $q.defer();
            var params = {
                'serviceid': 'emergency',
                'modelid': 'getemergencynavigation'
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.incidentList = data;
                deferred.resolve($scope.data.incidentList);
            });
            return deferred.promise;
        }

        /**
         * [selectIncidentTitle 安全事件单选功能]
         * @param  {[type]} item [选中的事件]
         * @return {[type]}      [null]
         */
        $scope.selectIncidentTitle = function(item) {
            var n = $scope.data.selectedIncident.indexOf(item);
            if (n > -1) {
                $scope.data.selectedIncident.splice(n, 1); //如果查找到，就将该条数据，从数组中移除
            } else {
                $scope.data.selectedIncident.push(item); //如果没有找到，就将该条数据塞进去
            }
        }


        /**
         * [getSelectedSafetyType 获取各项领域信息]
         * @return {[type]} [null]
         */
        $scope.getSelectedSafetyType = function() {
            $scope.params.field = $scope.status.selectedSafetyType.value;
            requestData();
        }

        /**
         * [selectIncidentAll 全选功能]
         * @return {[type]} [null]
         */
        $scope.selectIncidentAll = function() {
            if ($scope.data.selectedIncident.length != $scope.data.incidentList.length && $scope.data.incidentList.length > 0) {
                $scope.data.selectedIncident = [];
                for (var i in $scope.data.incidentList) {
                    $scope.data.selectedIncident.push($scope.data.incidentList[i].dictNum);
                }
            } else {
                $scope.data.selectedIncident = [];
            }
        }

        /**
         * [saveAndCheck 保存查看信息]
         * @return {[type]} [null]
         */
        $scope.saveAndCheck = function() {
            if($scope.data.selectedIncident.length==0){
                modalDialog.alertType("请选择事故类型","","warning",false);
                return;
            }
            var navId = $scope.data.selectedIncident.join(';');
            var params = {
                'serviceid': 'emergency',
                'modelid': 'saveconfig',
                'navigation': navId
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function() {
                requestData();
            });
        }

        /**
         * [clearFiltrate 清楚筛选]
         * @return {[type]} [description]
         */
        $scope.clearFiltrate = function() {
            $scope.data.selectedIncident = [];
        };

        /**
         * [监听时间变动]
         * @param  {String} ) {         if       ($scope.data.checkDate ! [当时间不是为空的时候，将它格式化]
         * @return {[type]}   [null]
         */
        $scope.$watch('data.checkDate', function() {
            if ($scope.data.checkDate != '') {
                var safetyDate = Date.parse($scope.data.checkDate);
                $scope.params.search_date = timeSwitch(safetyDate);
            }
            requestData();
        });

        /**
         * [changePageNum 点击分页加载数据]
         * @return {[type]} [null]
         */
        $scope.pageChanged = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // $scope.selectPageNum = function() {
        //     $scope.params.page_no = $scope.page.CURRPAGE - 1;
        //     $scope.params.page_size = $scope.page.PAGESIZE;
        //     $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        //     requestData();
        // };
        /**
         * [jumpToPage description:跳转指定页面]
         */
        // $scope.jumpToPage = function() {
        //     if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
        //         $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
        //     } else if ($scope.status.copyCurrPage < 1) {
        //         $scope.status.copyCurrPage = 1;
        //     }
        //     $scope.params.page_no = $scope.status.copyCurrPage - 1;
        //     $scope.page.CURRPAGE = $scope.status.copyCurrPage;
        //     requestData();
        // };

        /**
         * [querySearchKeywords 关键字快速搜索]
         * @return {[type]} [null]
         */
        $scope.querySearchKeywords = function(ev) {
            // $scope.status.showKeywords = true;
            if (angular.isDefined(ev) && ev.keyCode == 13 || angular.isUndefined(ev)) {
                $scope.params.search_word = $scope.status.keywords;
                $scope.status.showKeywords = $scope.status.keywords;
                requestData();
            }

        };


        $scope.clearKeywords = function() {
            $scope.status.keywords = $scope.status.showKeywords = '';
            $scope.params.search_word = '';
            requestData();
        }
        /**
         * [getChooseTimeType description] 筛选时间
         * @return {[type]} [description]
         */
        $scope.getChooseTimeType = function() {
            $scope.params.search_date = $scope.data.fromDate + ';' + $scope.data.untilDate;
            if($scope.params.search_date ==";"){
                $scope.params.search_date  = "";
            } 
            requestData();
        }
    }]);